<template>
    <div class="qr-container">
        <canvas ref="qrCanvas"></canvas>
    </div>
  </template>
  
  <script>
  import QRCode from 'qrcode';
  
  export default {
    props: {
      qrData: {
        type: String,
        required: true,
      },
    },
    mounted() {
      this.generateQRCode();
    },
    methods: {
      generateQRCode() {
        const canvas = this.$refs.qrCanvas;
        QRCode.toCanvas(canvas, this.qrData, {
            errorCorrectionLevel: 'H',
            margin: 0,
            width: 200,
        }, (error) => {
            if (error) console.error(error);
        });
      },
    },
  };
  </script>
  


// WEBPACK FOOTER //
// resources/assets/js/valuation-tool/components/Sections/QrCode.vue